export const STRING_REGEX = /^[a-zA-Z0-9_\s('!&@/$"`'‘’“”´)-=:]*$/
export const PNG_MIME_TYPE = 'image/png'

// Dropdown values
export const MIN_CHAR_COUNT = 2
export const SEARCH_HINT = `Type to search facilities`

export const getFacilityNoOptionsMessage = (inputValue: string) => {
  if (!inputValue || inputValue.length < MIN_CHAR_COUNT) {
    return SEARCH_HINT
  }
  return `No facilities found matching "${inputValue}"`
}

export const SEARCH_DEBOUNCE_TIME = 250

export const maxLength = (value: number) => ({
  value,
  message: `Must be less than ${value} characters`,
})

export const isValidFileType = (fl: FileList): boolean => {
  if (fl?.length === 0) {
    return true
  }
  return fl?.[0]?.type === PNG_MIME_TYPE
}

export const MAX_QUICK_REPORT_NAME_CHARACTERS = 32

export const MAX_ANNOUNCEMENT_MESSAGE_LENGTH = 1000
